<template>
  <div class="bottom-box flex-row justify-center" :style="{height: info.height,background: info.backgroundColor}">
    <img class="bg-img" v-if="info.background" :src="info.background" alt="">
    <div class="img-box">
      <template v-for="item in list">
        <img v-if="item.image" class="img-item" :src="item.image" alt="" :style="item.style">
      </template>
      <div class="bottom-content">
        <div class="bottom-show" v-html="info.content"></div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'bottom',
    data() {
      return {
        num: 0,
        info: {},
        list: []
      }
    },
    watch:{
      '$route':{
        handler(e){
          this.getBottom()
        },
        immediate: true
      }
    },
    created() {
      // this.getBottom()
    },
    methods: {
      getBottom(){
        if(this.num===20) return
        let website_id = localStorage.getItem('WEBSITE_ID')
        if(!website_id){
          setTimeout(()=>{
            this.getBottom()
            this.num += 1
          },10)
        }else{
          let params = {
            page_type: 'bottom'
          }
          this.$api.get('/api/H5/website/pc_temp',{params:params}).then(res => {
          	this.info = res.data
            this.list = res.data.list
          })
        }
      },
    }
  }
</script>

<style lang="less">
  .bottom-box{
    width: 100%;
    min-width: 1250px;
    // height: 225px;
    background-color: #ffffff;
    position: relative;
    .bg-img{
      width: inherit;
      height: inherit;
      position: absolute;
      top: 0;
      left: 0;
    }
    .img-box{
      width: 1250px;
      margin: 0 auto;
      display: flex;
      overflow: hidden;
    }
    .img-item{
      position: relative;
    }
    .bg-img{
      width: 100%;
      height: inherit;
      position: absolute;
      top: 0;
      left: 0;
    }
    .bottom-content{
      width: inherit;
      position: absolute;
      top: 0;
    }
    .bottom-show{
      position: relative;
      // min-height: 100px;
      p, h1, h2, h3, h4, h5, table, pre {
        margin: 0;
        line-height: 1.5;
      }
      img{
        display: inline-flex;
      }
    }
  }
  .footer-line{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    font-size: 14px;
    background-color: #fff;
  }
  /deep/ .upload-demo {
    .el-upload-list__item {
      transition: none !important;
    }
    .el-upload-list {
      height: 92px;
      margin-top: 10px;
      background-color: #ffffff;
    }
  }
  .special {
    align-items: flex-end;
    .value{
      width: 100px;
    }
  }
  .row-line {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .margin-left {
    margin-left: 20px;
  }
  .content-item{
    display: flex;
    align-items: center;
  }
  .label {
    padding: 10px 0;
    font-size: 16px;
  }
  .value{
    width: 100px;
  }
  @media screen and (max-width: 1100px) {
    .bottom-box{
      min-width: unset;
      .img-box{
        width: 100%;
        margin: 0 auto;
        display: flex;
        overflow: hidden;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue